import { get, put,Delete,post } from '../axios'

// 设备日志-列表
export const logList = params => get(`/web/device/log/list`,params);


